module.exports = __webpack_public_path__ + "img/Réalisation garde-corps bicoloration.9f38ada8.jpg";